module.exports = __webpack_public_path__ + "img/security-check-icon.5ffa6536.png";